var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"dashed-loader"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }